import log, {logError} from './logger';

import Smartlook from 'smartlook-client';

export const initializeSmartlook = () => {
  try {
    const disabledEnvironments = ['cert', 'qual'];
    const environment = process.env.REACT_APP_ENVIRONMENT;
    const projectKey = process.env.REACT_APP_SMARTLOOK_PROJECT_KEY;

    if (disabledEnvironments.includes(environment)) {
      log.info(`Smartlook disabled for ${environment} environment`);
      return false;
    }

    Smartlook.init(projectKey, {
      region: 'eu',
      recordCrashes: true,
    });

    return true;
  } catch (error) {
    logError('Smartlook initialization failed', error);
    return false;
  }
};
